module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d450e61af073265282cfdf43e7c61e96.gif";